<div class="oqs-section-icon">
  <span class="fa" ng-class="oqsSection.section.definition.attributes.icon"></span>
</div>
<div class="oqs-section-questions row">
  <div ng-if="oqsSection.section.definition.description" class="col-xs-12">
    <h5 ng-click="oqsSection.hidden = !oqsSection.hidden" class="oqs-section-toggle"
        ng-bind="oqsSection.section.definition.description"></h5>
  </div>
  <div ng-hide="oqsSection.hidden" class="col-xs-12 ng-animate oqs-animate-fade-right">
    <uib-tabset ng-if="oqsSection.section.definition.attributes.multiple">
      <uib-tab active="oqsSection.tabs[$index].active"
               ng-repeat="sectionInstance in oqsSection.section.instanceList track by $index">
          <uib-tab-heading ng-class="{'has-error': !oqsSection.isSectionInstanceValid($index)}">{{oqsSection.truncateString(sectionInstance.getHeading(),25)}}
            <a ng-if="oqsSection.tabs.length > 1" ng-click="oqsSection.removeSectionInstance($index)">
              <span class="fa fa-times"></span>
            </a>
          </uib-tab-heading>
        <div class="form-horizontal">
          <div class="oqs-question-group-container" ng-repeat="question in sectionInstance.questionList">
            <oqs-question-control oqs-question-model="question"
                                  oqs-validation-active="oqsSection.validationActive"
                                  oqs-section-instance="sectionInstance"></oqs-question-control>
          </div>
        </div>
      </uib-tab>
      <uib-tab ng-if="oqsSection.isSectionAllowed()" disable="true" ng-click="oqsSection.addSectionInstance()" class="oqs-tabs-add">
        <uib-tab-heading><span class="fa fa-plus-square"></span> <span>Add another {{oqsSection.section.definition.attributes.heading}}</span></uib-tab-heading>
      </uib-tab>
    </uib-tabset>
    <div ng-if="!oqsSection.section.definition.attributes.multiple" class="form-horizontal">
      <div class="oqs-question-group-container" ng-repeat="question in oqsSection.section.instanceList[0].questionList">
        <oqs-question-control oqs-question-model="question"
                              oqs-validation-active="oqsSection.validationActive"
                              oqs-section-instance="oqsSection.section.instanceList[0]"></oqs-question-control>
      </div>
    </div>
  </div>
</div>
